import { KnownDeliveryDtoState, KnownOrderDtoStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import { ValidOrderStatusChangeOption } from './open-locker-action.hook';
import { BookingFlowType } from '../../../../../ui/enums/booking-flow-type.enum';

export const openIntentMessage: { [key in KnownOrderDtoStatus]: string } = {
  booked: '',
  'in-progress': 'The locker is expecting a parcel',
  'retrieval-required': 'The locker contains a parcel',
  cancelled: 'The parcel was cancelled',
  collected: 'The parcel has already been collected',
  retrieved: 'The parcel has already been retrieved',
  delivered: 'The locker contains a parcel',
  'delivered-offline': 'The locker contains a parcel',
  overdue: 'The locker contains a parcel'
};

export function canChangeStatus(status: KnownDeliveryDtoState | KnownOrderDtoStatus): boolean {
  switch (status) {
    case KnownDeliveryDtoState.Collected:
    case KnownDeliveryDtoState.Cancelled:
    case KnownDeliveryDtoState.Retrieved:
    case KnownOrderDtoStatus.Booked:
      return false;
    default:
      return true;
  }
}

export const updateStatusOptions: { label: string; value: ValidOrderStatusChangeOption }[] = [
  { label: 'Collected - The customer has the order', value: 'collected' },
  { label: 'Cancelled - It was incorrectly/unsuccessfully delivered', value: 'cancelled' },
  { label: 'Retrieved - It has been taken back by the retailer', value: 'retrieved' }
];

/**
 * Gets filtered status options based on booking flow type
 * @param bookingFlowType The resolved booking flow type
 * @returns Filtered status options array, excluding 'retrieved' for INVENTORY flow projects
 */
export function getUpdateStatusOptions(
  bookingFlowType: BookingFlowType
): { label: string; value: ValidOrderStatusChangeOption }[] {
  const isInventoryFlow = bookingFlowType === BookingFlowType.INVENTORY;

  if (isInventoryFlow) {
    return updateStatusOptions.filter((option) => option.value !== 'retrieved');
  }

  return updateStatusOptions;
}

export function getModalTitle(tag: 'OPEN_LOCKER'): string;
export function getModalTitle(tag: 'CHANGE_STATUS', currentStatus: KnownOrderDtoStatus): string;
export function getModalTitle(tag: 'OPEN_LOCKER' | 'CHANGE_STATUS', currentStatus?: KnownOrderDtoStatus): string {
  switch (tag) {
    case 'OPEN_LOCKER':
      return 'Open locker?';
    case 'CHANGE_STATUS':
      switch (currentStatus) {
        case KnownOrderDtoStatus.Collected:
        case KnownOrderDtoStatus.Cancelled:
        case KnownOrderDtoStatus.Retrieved:
          return 'Success';
        default:
          return 'Also change the status?';
      }
    default:
      return '';
  }
}
